import React from "react";
import { Button, Grid } from "semantic-ui-react";

export const Confirm = props => {
  const { handleConfirm, handleDeny, confirmMsg = null } = props;
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center"
          }}
        >
          <div>
            <h4>Are you sure?</h4>
            {confirmMsg}
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: 0 }}>
        <Grid.Column style={{ display: "flex" }}>
          <Button
            primary
            style={{ flex: 1 }}
            content="Yes"
            onClick={handleConfirm}
            className="success"
          />
          <Button
            style={{ flex: 1 }}
            content="No"
            onClick={handleDeny}
            className="error"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
